import React from 'react'
import Divider from '@material-ui/core/Divider'
import PropTypes from 'prop-types'
import { NavBarItem } from './nav-bar-item'

export const ROOT_LEVEL = 0

export class NavBar extends React.PureComponent {

    static propTypes = {
        id: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.object),
        defaultSelectedItem: PropTypes.object,
        selectedItem: PropTypes.object,
        expandedItems: PropTypes.arrayOf(PropTypes.object),
        level: PropTypes.number,
        onItemSelect: PropTypes.func,
        onItemExpand: PropTypes.func
    }

    static defaultProps = {
        id: 'navBar',
        items: [],
        level: ROOT_LEVEL,
        onItemSelect: () => null,
        onItemExpand: () => null,
    }

    state = {
        expandedItems: [],
    }

    componentDidMount() {
        const { selectedItem } = this.props
        this.expandItemParent(selectedItem)
    }

    componentDidUpdate(prevProps) {
        // При изменении выделения - раскрываем родителей
        if (this.props.selectedItem !== prevProps.selectedItem) {
            this.expandItemParent(this.props.selectedItem)
        }
    }

    expandItemParent = item => {
        const { level, items, onItemExpand } = this.props
        if (item && level === ROOT_LEVEL) {
            const expandedItems = [...this.state.expandedItems]
            const dataLookUp = expandedItems.map(expandedItem => expandedItem.data)
            let currentItem = item

            while (currentItem) {
                const parent = findParent(currentItem, items)

                // Добавляем только если уже не был раскрыт
                if (parent && dataLookUp.indexOf(parent.data) === -1) {
                    expandedItems.push(parent)
                    dataLookUp.push(parent.data)
                }
                currentItem = parent
            }

            expandedItems.forEach(expandedItem => onItemExpand(expandedItem))

            this.setState({
                expandedItems
            })
        }
    }

    itemExpandHandler = item => {
        const { level, onItemExpand } = this.props
        const { expandedItems } = this.state
        if (level > ROOT_LEVEL) {
            onItemExpand(item)
        } else {
            const foundExpandedItem = expandedItems.find(expandedItem => expandedItem.id === item.id)
            const newExpandedItems = expandedItems.concat()
            if (foundExpandedItem) {
                newExpandedItems.splice(newExpandedItems.indexOf(foundExpandedItem), 1)
            } else {
                newExpandedItems.push(item)
            }
            this.setState({
                expandedItems: newExpandedItems
            })
        }
    }

    render() {
        const {
            items, level, defaultSelectedItem, selectedItem,
            expandedItems: propsExpandedItems, onItemSelect, onItemExpand, ...other
        } = this.props
        const { expandedItems } = this.state

        const components = []
        let prevItem = null

        const addItem = item => {
            if (item.hidden) return

            const folder = isFolder(item)
            const selected = (selectedItem && item.id === selectedItem.id) || false

            components.push(
                <NavBarItem
                    key={item.id}
                    item={item}
                    level={level}
                    selected={selected}
                    expanded={expandedItems.some(expandedItem => item.id === expandedItem.id)}
                    childNavBarProps={folder ? {
                        selectedItem,
                        expandedItems: level === ROOT_LEVEL ? expandedItems : propsExpandedItems,
                    } : null}
                    onItemSelect={onItemSelect}
                    onItemExpand={this.itemExpandHandler}
                />
            )
        }

        items.forEach(item => {
            if (isItemsGroup(item) && !haveVisibleItemsInGroup(item)) return

            if (isItem(item) && isFolder(item) && !haveVisibleItemsInFolder(item)) return

            if (isItemsGroup(prevItem)) {
                components.push(<Divider key={`groupEnd${prevItem.id}`}/>)
            }

            if (isItemsGroup(item)) {
                if (!isItemsGroup(prevItem)) {
                    components.push(<Divider key={`groupStart${item.id}`}/>)
                }
                item.items.forEach(addItem)
            }

            if (isItem(item)) {
                addItem(item)
            }

            prevItem = item
        })

        return (
            <div {...other}>
                {components}
            </div>
        )
    }
}

export const isItem = item => {
    if (!item) return false
    return item.label !== undefined
        && item.id !== undefined
}

export const isItemsGroup = group => {
    if (!group) return false
    return group.items !== undefined
        && group.id !== undefined
}

export const isFolder = item => {
    if (!item) return false
    return item.children !== undefined
}

export const haveVisibleItemsInFolder = folder => {
    if (!folder || !isFolder(folder) || folder.children.length === 0) return false
    return folder.children.some(item => {
        if (isFolder(item) && !item.hidden) return haveVisibleItemsInFolder(item)

        return !item.hidden
    })
}

export const haveVisibleItemsInGroup = group => {
    if (!group || !isItemsGroup(group) || group.items.length === 0) return false
    return group.items.some(item => {
        if (isFolder(item) && !item.hidden) return haveVisibleItemsInFolder(item)

        return !item.hidden
    })
}

export const findParent = (item, parents) => {
    if (!item || !parents) return null

    let foundItem = null
    parents.forEach(current => {
        if (foundItem) return

        if (isItemsGroup(current)) {
            const parent = findParent(item, current.items)
            if (parent) {
                foundItem = parent
            }
        }
        if (isItem(current) && isFolder(current)) {
            if (current.children.some(child => child.id === item.id)) {
                foundItem = current
            } else {
                const parent = findParent(item, current.children)
                if (parent) {
                    foundItem = parent
                }
            }
        }
    })

    return foundItem
}
